import { createThemes } from "../../../../../styles/common/themes.js";
import { ThemeId } from "../../../../../styles/types/theme.js";
import logitravelTabsStyles from "./styles/logitravel.js";
import partnershipsTabsStyles from "./styles/partnerships.js";
import smyTabsStyles from "./styles/smy.js";
import veciTabsStyles from "./styles/veci.js";
const tabsThemes = createThemes({
    [ThemeId.logitravel]: logitravelTabsStyles,
    [ThemeId.partnerships]: partnershipsTabsStyles,
    [ThemeId.smy]: smyTabsStyles,
    [ThemeId.veci]: veciTabsStyles
});
export default tabsThemes;

//# sourceMappingURL=index.js.map